<app-traitement-data titre="Mode" [sousTitre]="patient!.tableauDeBord?.mode?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.mode?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.mode?.value == 'PEP FIXE' ? 'ASV' : patient!.tableauDeBord?.mode?.value == 'PEP AUTO' ?
    'ASV AUTO' : patient!.tableauDeBord?.mode?.value ?? 'Pas de donnée' }}
</app-traitement-data>